import type { en } from "./en.ts";

export const fr: typeof en = {
    Navigation: {
        me: {
            label: "Moi",
            description: "Votre profil"
        }
    },
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Aller à",
        openNavigation: "Ouvrir la navigation",
        closeNavigation: "Fermer la navigation",
        primaryNavigation: "Principale",
        openUserMenu: "Ouvrir le menu de l’espace de travail et de l’utilisateur",
        accountSettings: "Paramètres personnels",
        organizationSettings: "Paramètres de l’organisation",
        workspace: "Espace de travail",
        currentWorkspace: "Espace de travail actuel",
        switchWorkspaceError: "Impossible de changer d’espace de travail. Veuillez réessayer.",
        loadingWorkspaces: "Chargement des espaces de travail",
        switchingWorkspace: "Changement d’espace de travail",
        logout: "Se déconnecter",
        helpCenter: "Centre d’aide",
        helpCenterUrl: "https://help.workleap.com/fr/collections/19772749-le-nouveau-workleap",
        opensInNewTab: "s’ouvre dans un nouvel onglet",
        takeTheTour: "Faire la visite guidée",
        resizeAgentPanel: "Redimensionner le panneau de l’agent",
        skipToMainContent: "Passer au contenu principal"
    },
    AssistantTabIndicator: {
        working: "En cours…",
        done: "Terminé",
        error: "Erreur"
    },
    CreateMenu: {
        create: "Créer",
        newSurvey: "Nouveau sondage",
        newReviewCycle: "Nouveau cycle d’évaluation",
        newPlan: "Nouveau plan"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Fermer le menu",
        collapseNavigation: "Réduire la navigation",
        expandNavigation: "Développer la navigation"
    },
    TabsLayout: {
        tabs: "Onglets",
        externalTab: {
            title: "Vous quittez Workleap",
            body: "{{appName}} s’ouvre dans un nouvel onglet.",
            cancel: "Annuler",
            continue: "Continuer",
            newTab: "(s’ouvre dans un nouvel onglet)"
        }
    },
    SectionMenuTrigger: {
        openMenu: "{{title}}, ouvrir le menu"
    },
    ModuleErrorBoundary: {
        title: "Une erreur est survenue",
        description: "Nous n’avons pas pu charger cette page. Vous pouvez réessayer ou retourner à l’accueil.",
        retry: "Réessayer",
        goHome: "Retour à l’accueil"
    },
    NotFoundPage: {
        title: "Page introuvable",
        code: "404",
        description: "Cette page est introuvable.",
        backHome: "Retour à l’accueil"
    },
    OrganizationAccessPage: {
        title: "Non disponible",
        heading: "Pas encore disponible pour votre organisation",
        body: "Votre organisation n’a pas accès à la nouvelle expérience Workleap. Vous pouvez continuer à utiliser l’expérience Workleap classique.",
        backToWorkleap: "Retour à Workleap"
    },
    RootErrorBoundary: {
        title: "Une erreur est survenue",
        description: "L’application n’a pas pu démarrer. Essayez de rafraîchir la page ou de retourner à l’accueil.",
        goHome: "Retour à l’accueil"
    },
    BootstrappingRoute: {
        loading: "Chargement"
    },
    unmanagedMutationErrors: {
        toastMessage: "Une erreur est survenue. Veuillez réessayer."
    },
    CommandMenu: {
        placeholder: "Aller à",
        noResults: "Aucun résultat ne correspond à votre recherche.",
        searching: "Recherche...",
        dialogLabel: "Palette de commandes",
        searchLabel: "Recherche rapide",
        sections: {
            people: "Personnes",
            teams: "Équipes"
        },
        memberCount_one: "{{count}} membre",
        memberCount_other: "{{count}} membres",
        footer: {
            navigate: "naviguer",
            open: "ouvrir",
            escToClose: "esc pour fermer"
        }
    },
    ProductTour: {
        stepCounter: "{{current}} sur {{total}}",
        skip: "Passer la visite",
        back: "Retour",
        next: "Suivant",
        done: "Terminé",
        stepAnnouncement: "Étape {{current}} sur {{total}} : {{title}}"
    },
    OnboardingProductTour: {
        agent: {
            title: "Votre agent IA, sur chaque page",
            body: "Votre agent s’appuie sur vos résultats d’engagement, vos objectifs, vos Bonnes Vibes et vos applications connectées pour préparer l’ordre du jour de vos réunions, rédiger vos réponses aux feedbacks et vos évaluations de performance, prêts à être modifiés."
        },
        navigation: {
            title: "Tout ce qu’il vous faut, à portée de main",
            bodyIndividual: "Vos Bonnes Vibes, vos objectifs, vos évaluations et plus encore, ainsi que tout ce qui concerne l’organisation.",
            bodyTeam: "Engagement, objectifs, Bonnes Vibes, évaluations de performance, réunions et plus encore, sous l’angle qu’il vous faut."
        },
        shortcuts: {
            title: "Allez droit au but",
            body: "Trouvez n’importe quelle personne ou page, où que vous soyez. Utilisez + pour créer des Bonnes Vibes, du feedback, des objectifs et plus encore."
        },
        analytics: {
            title: "Aidez chaque équipe à s’épanouir",
            body: "Comparez la situation des équipes pour voir où votre soutien fera la plus grande différence."
        },
        restart: {
            title: "L’aide n’est jamais loin",
            body: "Ouvrez le menu de votre profil pour refaire la visite ou consulter le centre d’aide."
        }
    }
};
